import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getAllUserListForChat = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETALLUSERLISTFORCHAT,
    params
  );
  return data;
};
const getUserListForChating = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETUSERLISTFORCHATING,
    params
  );
  return data;
};
const userChatStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.USERCHATSTATUSUPDATE, params);
  return data;
};
const getActivePropertyList = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETCPACTIVEPROPERTYLIST,
    params
  );
  return data;
};
const getPropertyUserListForChat = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETPROPERTYUSERLISTFORCHAT,
    params
  );
  return data;
};

const chatService = {
  getAllUserListForChat,
  getUserListForChating,
  userChatStatusUpdate,
  getActivePropertyList,
  getPropertyUserListForChat,
};

export default chatService;
